import React, { Component } from 'react';
import { leadID } from '../Services/fetchService';
import {
    DomField,
    DomSelect,
    DomBoolCheckbox,
    DomTextarea,
    DomCustomImage
} from '../Services/formDOM';
import { checkInput, returnValue } from '../Services/Validation';
import { GA_Push } from '../Services/GoogleAnalytics';
import { apiURL, Environment } from '../Services/Base';
import Loading from '../Services/Loading/Loading';
import 'whatwg-fetch';
import './Body.scss';

export default class Body extends Component {
    constructor() {
        super();
        this.state = {
            isOpen: false,
            isBusy: false,
            isLoading: false,
            // isLoading: true,
            pageStyle: 'form',
            // pageStyle: "done",
            // pageStyle: "already",
            FileName: {
                value: '',
                name: 'FileName',
                error: '',
                isRequired: true,
                shouldValidate: true,
                ImagePlaceholder: '<span>צירוף תמונה עד</span> <span>5MB</span> <span>(JPEG, PNG,GIF)</span>'
            },
            captchaEnable: !Environment().isLocalhost
        };
        window.sendCallback = this.sendForm;
    }

    componentDidMount() {
        if (!!window.localStorage.getItem('AlreadySent') === true) {
            this.setState({ pageStyle: 'already' });
            return;
        }
        (() => {
            if (window.document.getElementById('GoogleRecap')) return;

            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'GoogleRecap';
            script.async = 1;
            script.defer = 1;
            script.src = 'https://www.google.com/recaptcha/api.js';

            document.getElementsByTagName('head')[0].appendChild(script);
        })();
    }

    addState = (stateName, isRequired, shouldValidate) => {
        this.setState({
            [stateName]: {
                name: stateName,
                value: '',
                isRequired: !isRequired ? false : true,
                shouldValidate: !shouldValidate ? false : true
            }
        });
    };

    handleInputChange = event => {
        // if (event.target.value.length > 200) return;
        this.setState({
            [event.target.name]: {
                ...this.state[event.target.name],
                error: '',
                value:
                    event.target.dataset && event.target.dataset.bool === 'true'
                        ? this.state[event.target.name].value
                            ? 0
                            : 1
                        : event.target.value
            }
        });
    };

    setErrorMessage = (target, errorMsg) => {
        if (!this.state[target.name]) return;

        this.setState({
            [target.name]: {
                ...target,
                error: errorMsg
            }
        });
    };

    openModal = () => this.setState({ isOpen: true });

    setPage = pageStyle =>
        this.setState({
            pageStyle: pageStyle
        });

    checkString = event => {
        let { name, value } = event.target;
        switch (name) {
            default:
                return value;
        }
    };

    onlyLetters = string => string.replace(/[0-9]/i, '');

    onlyNumbers = string =>
        string.replace(/[+\\/!*@#$%^&a-zA-Z\-\u0590-\u05FF]/i, '');

    changeImageLabel = event => {
        var allowdExtensions = ['jpg', 'jpeg', 'gif', 'png'];
        var file = event.target.files[0];
        if (file) {
            if (file.size > 5242880) {
                alert('לא ניתן להעלות קבצים מעל 5mb');
                event.target.value = '';
                return false;
            }

            var isAllowd = false;
            allowdExtensions.forEach(extension => {
                if (file.type.indexOf(extension) > -1) {
                    isAllowd = true;
                }
            });

            if (!isAllowd) {
                alert('ניתן לעלות רק קבצי תמונה');
                event.target.value = '';
                return false;
            }

            console.log(file);
            this.setState({
                FileName: {
                    ...this.state.FileName,
                    name: file.name,
                    value: file,
                    error: '',
                    label: '',
                    ImagePlaceholder: file.name,
                    id: 'FileName'
                }
            });
        } else {
            return false;
        }
    };

    saveAndValidate = async () => {
        if (this.state.isBusy) return;

        this.setState({
            isLoading: true,
            isBusy: true
        });

        let isError = false,
            j = 0,
            jsonBody = {},
            stateValidate = Object.filter(this.state, s => s.shouldValidate),
            state = Object.filter(this.state, s => s.isRequired),
            fieldstateValidateKeys = Object.keys(stateValidate),
            fieldStateKeys = Object.keys(state);

        for (let s in stateValidate) {
            if (await !checkInput(stateValidate[s], this.setErrorMessage))
                isError = true;
            j++;
        }

        for (let k in fieldStateKeys) {
            jsonBody = Object.assign(jsonBody, {
                [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
            });
        }

        if (isError && j == fieldstateValidateKeys.length) {
            this.setState({
                isLoading: false,
                isBusy: false
            });
            return;
        }

        this.setState(
            {
                jsonBody,
                isLoading: true,
                isBusy: true
            },
            () =>
                this.state.captchaEnable
                    ? window.grecaptcha.execute()
                    : this.sendForm()
        );
    };

    sendForm = async () => {
        let formData = new FormData();
        let formDataEmailPhone = new FormData();
        const { jsonBody } = this.state;
        console.log(jsonBody);

        formData.append('LeadID', leadID.toString());
        formDataEmailPhone.append('LeadID', leadID.toString());
        for (let k = 0; k < Object.keys(jsonBody).length; k++) {
            let _key = Object.keys(jsonBody)[k];
            formData.append(_key, jsonBody[_key]);
            if (_key == 'PhoneNumber' || _key == 'Email') {
                formDataEmailPhone.append(_key, jsonBody[_key]);
            }
        }

        this.state.captchaEnable ? window.grecaptcha.reset() : null;

        fetch(`${apiURL}Save`, {
            method: 'POST',
            body: formData
        })
            .then(data => data.json())
            .then(data => {
                this.setState({
                    isLoading: false,
                    isBusy: false,
                    pageStyle: 'done'
                });
                GA_Push(
                    'Form_Events',
                    'Form Sent',
                    'Laisha With my beautiful',
                    'Lead Form'
                );
                // GA_Push("GA_Events", "form_sent");
                window.localStorage.setItem('AlreadySent', true);
                if (this.state.captchaEnable) {
                    window.grecaptcha.reset();
                }
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    isBusy: false
                });
            });
    };
    render() {
        return (
            <section className={`section-form ${this.state.pageStyle}`}>
                <div className="wrapper">
                    <div className="res_wrapper">
                        <DomField
                            className="reg_input"
                            type="text"
                            max={64}
                            label="שם מלא"
                            placeholder="שם מלא"
                            name="FullName"
                            id="FullName"
                            isRequired
                            shouldValidate
                            onChange={this.handleInputChange}
                            onLoad={this.addState}
                            {...this.state}
                        />
                        <DomField
                            className="reg_input"
                            type="text"
                            max={100}
                            label="כתובת"
                            placeholder="כתובת"
                            name="PlainText2"
                            id="PlainText2"
                            isRequired
                            shouldValidate
                            onChange={this.handleInputChange}
                            onLoad={this.addState}
                            {...this.state}
                        />
                    </div>
                    <div className="res_wrapper">
                        <DomField
                            className="reg_input"
                            type="tel"
                            max={64}
                            label="טלפון"
                            placeholder="טלפון"
                            name="PhoneNumber"
                            id="PhoneNumber"
                            isRequired
                            shouldValidate
                            onChange={this.handleInputChange}
                            onLoad={this.addState}
                            {...this.state}
                        />
                        <DomField
                            className="reg_input"
                            type="email"
                            max={100}
                            label='דוא"ל'
                            placeholder='דוא"ל'
                            name="Email"
                            id="Email"
                            isRequired
                            shouldValidate
                            onChange={this.handleInputChange}
                            onLoad={this.addState}
                            {...this.state}
                        />
                    </div>
                    <DomTextarea
                        className="texterea"
                        _settings={{
                            maxLength: 5000
                        }}
                        type="text"
                        label="סיפור המתכון ( כיצד נולד, איזה גלגולים עבר, מי מבני המשפחה מכין או שכולם יחד ועוד ) + המתכון המלא"
                        placeholder="סיפור המתכון ( כיצד נולד, איזה גלגולים עבר, מי מבני המשפחה מכין או שכולם יחד ועוד ) + המתכון המלא"
                        name="PlainText"
                        id="PlainText"
                        className=""
                        isRequired
                        shouldValidate
                        onChange={this.handleInputChange}
                        onLoad={this.addState}
                        {...this.state}
                    />
                    <DomCustomImage
                        type="file"
                        label="תמונה"
                        placeholder={this.state.FileName.ImagePlaceholder}
                        name="FileName"
                        id="FileName"
                        isRequired
                        shouldValidate
                        onChange={this.changeImageLabel}
                        onLoad={this.addState}
                        {...this.state}
                    />
                    <Loading showLoading={this.state.isLoading} />
                    <DomBoolCheckbox
                        label={`קראתי הבנתי ומסכים ל<a target="_blank" href="">תקנון</a>
                          הפעילות, 
                          <a target='_blank' href='https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html'>מדיניות הפרטיות </a>
                          וקבלת דיוורים מ-ynet
                          ,אסם, נסטלה, נסקפה, מטקנה, גרבר, טבעול, צבר, בונז'ור, ויטמינצ'יק , סטרבאקס, קיטקט, סמארטיס, בישולים ופורינה.`}
                        type="checkbox"
                        name="TOS"
                        id="TOS"
                        className="cb"
                        shouldValidate
                        onChange={this.handleInputChange}
                        onLoad={this.addState}
                        {...this.state}
                    />
                    <div
                        className="button"
                        onClick={() => {
                            this.saveAndValidate();
                        }}>
                        <div
                            className="g-recaptcha"
                            data-callback="sendCallback"
                            data-size="invisible"
                            data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"></div>
                    </div>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Body/Body.jsx